import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import * as RoutesDefinitions from '../../routes-definitions';

@Injectable({
	providedIn: 'root'
})
export class HasFederationsGuard implements CanActivate {
	hasFederations$ = of(true); // this.store.select(FederationsStoreSelectors.selectHasFederations);
	hasLoadedOnce$ = of(true); // this.store.select(FederationsStoreSelectors.selectHasLoadedOnce);

	private router = inject(Router)

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
		return this.hasLoadedOnce$.pipe(
			filter(hasLoadedOnce => hasLoadedOnce),
			switchMap(_ => this.hasFederations$),
			map((hasFederations: boolean) => {
				// Allow this page without Federations only when coming from an invite
				// but the user has been inactivated since.
				if (!hasFederations && !route.fragment?.includes(RoutesDefinitions.InviteFragment)) {
					this.router.navigate([RoutesDefinitions.getNewAccountCompanyFullPath()]);
					return false;
				}
				return true;
			})
		);
	}
}
